import addLocale from './add-locale';
import removeLocale from './remove-locale';
import saveMainLocale from './save-main-locale';

export default {
  addLocale,
  removeLocale,
  saveMainLocale,
};
